<template>

  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
    height="100%"
  >
    <b-card
      class="d-flex justify-content-center"
    >
      <b-row v-if="alertShow">
        <b-col sm="12">
          <dashboard-alert
            variant="success"
            :description="$t('successful-deposit-registration')"
          />

        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
        >
          <div class="">
            <h3 class="">
              {{ $t('wireDepositTitle') }}
            </h3>
            <br>
            <div class="">
              <h5> {{ $t('wireDepositDescription') }}</h5>
              <br>
              <b-row
                v-if="bankAccountInfo"
              >
                <b-col>
                  <HistoryCard
                    :items="[bankAccountInfo]"
                    :fields="bankAccountFields"
                  >
                    <template #item(min_deposit_amount)="data">
                      <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.min_deposit_amount, data.item.currency.currency_decimal))+' '+data.item.currency.name }}</span>
                    </template>
                    <template #item(max_deposit_amount)="data">
                      <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.max_deposit_amount, data.item.currency.currency_decimal))+' '+data.item.currency.name }}</span>
                    </template>
                    <template #item(fee)="data">
                      <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.fee, data.item.currency.currency_decimal))+' '+data.item.currency.name }}</span>
                    </template>
                  </HistoryCard>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <validation-observer ref="depositform">
            <b-form class="mt-4">
              <b-row>
                <b-col md="3">
                  <b-form-group
                    label-for="Currency"
                    :label="$t('fiat_wallet_deposit_currency')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('fiat_wallet_deposit_currency')"
                      vid="Currency"
                      rules="required"
                      :required="!currency"
                    >
                      <v-select
                        id="Currency"
                        v-model="currency"
                        :options="options"
                        :placeholder="$t('fiat_wallet_deposit_currency')"
                        label="name"
                        track-by="name"
                        @input="onCurrencyChange"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group
                    label-for="bankAccountSelect"
                    :label="$t('bank')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('bank')"
                      vid="Bank"
                      rules="required"
                    >
                      <v-select
                        id="bankAccountSelect"
                        v-model="bankAccountInfo"
                        :options="bankAccounts"
                        :placeholder="$t('bank')"
                        label="bank_name"
                        track-by="account_number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="3"
                >
                  <b-form-group
                    :label="$t('fiat_wallet_deposit_amount')"
                    label-for="hear-description"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('fiat_wallet_deposit_amount')"
                      rules="required|numeric"
                    >

                      <b-form-input
                        v-model="amount"
                        name="hear-description"
                        :placeholder="$t('fiat_wallet_deposit_amount')"
                        autocomplete="nope"
                        @keypress="onlyNumbers($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="3"
                >
                  <b-form-group
                    :label="$t('deposit_Receipt')"
                    label-for="file-large"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('deposit_Receipt')"
                      :rules="'required|size:'+MAX_IMAGE_UPLOAD_SIZE"
                    >
                      <b-form-file
                        id="file-large"
                        v-model="file"
                        accept="image/png, image/jpg, image/jpeg"
                        :placeholder="$t('fiat_wallet_deposit_receipt_file')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-end"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2"
            :disabled="!bankAccountInfo"
            pill
            @click="submit"
          >
            <span v-if="!pending"> {{ $t('fiat_wallet_deposit_send_button') }}</span>
            <b-spinner
              v-else
              small
              type="grow"
            />
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- 4. Deposit History -->
    <b-card class="deposit-history">
      <h3 class="mb-0">
        {{ $t('deposit_history') }}
      </h3>
      <br>
      <HistoryCard
        :items="depositHistory"
        :fields="historyFields"
      >
        <template #item(amount)="data">
          <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.amount, 2)) }}</span>
        </template>
        <template #item(automation.status)="data">
          <span
            size="sm"
            :class=" data.item.automation.status === 'pending' ? 'text-warning' : data.item.automation.status === 'successful' ? 'text-success' :data.item.automation.status === 'rejected'? 'text-danger': 'text-info'"
          >
            {{ $t(data.item.automation.status) }}
          </span>
        </template>
      </HistoryCard>
    </b-card>
  </b-overlay>

</template>
<script>
import FiatDeposit from '@/modules/crypto/views/logic/customer-wallets/fiat/FiatDeposit'
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import HistoryCard from '../../components/historyCard.vue'

export default {
  components: {
    DashboardAlert,
    HistoryCard,
  },
  mixins: [FiatDeposit],
  computed: {
    bankAccountFields() {
      return [
        { key: 'card_number', label: this.$t('accountNumber') },
        { key: 'iban', label: this.$t('iban') },
        { key: 'card_name', label: this.$t('accountOwner') },
        { key: 'bank_name', label: this.$t('bank') },
        { key: 'min_deposit_amount', label: this.$t('min_deposit_amount') },
        { key: 'max_deposit_amount', label: this.$t('max_deposit_amount') },
        { key: 'fee', label: this.$t('fee') },
      ]
    },
  },
}
</script>
<style scoped>
.bg-dark-blue {
  background-color: rgb(2, 58, 110);
}
</style>
